import { useEffect } from 'react';
import { compareVersions } from '../utils/utils';
const buildVersion = process.env.APP_VERSION;
const useReload = (parsed) => {
    useEffect(() => {
        const checkReload = async () => {
            if (buildVersion &&
                parsed.APP_VERSION &&
                compareVersions(parsed.APP_VERSION, buildVersion)) {
                const banner = document.createElement('div');
                banner.innerText = `Nueva versión detectada (${buildVersion} → ${parsed.APP_VERSION}). Actualizando...`;
                Object.assign(banner.style, {
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    right: '0',
                    background: '#ffcc00',
                    color: '#000',
                    padding: '10px',
                    textAlign: 'center',
                    zIndex: 9999,
                    fontWeight: 'bold',
                });
                document.body.appendChild(banner);
                setTimeout(async () => {
                    const cacheNames = await caches.keys();
                    await Promise.all(cacheNames.map(c => caches.delete(c)));
                    window.location.reload();
                }, 3000);
            }
        };
        checkReload();
    }, [parsed]);
};
export default useReload;
